import styled from "styled-components";

const ModalFooter = styled.div `
  padding: 0 1.9rem 2.25rem 1.9rem;
  text-align: right;
`;

export default ModalFooter;
